import { FC, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  ChangeBgBtn,
  ProjectEditPageGridLabel,
  ProjectEditPageGridRow,
  UserColorChoose,
  UserColorChooseBlock
} from "../../styles";
import { ColorElement, ColorPickerWrapper } from "./styles";
import { Colors } from "@brg/ui";
import { useSelector } from "react-redux";
import SketchPicker from "react-color/lib/components/sketch/Sketch";
import ClickAwayListener from "react-click-away-listener";
import { useRouteMatch } from "react-router-dom";
import {
  CompetitionEditPageGridLabel
} from "../../../../../_competition/pages/CreateCompetitionPage/CreateCompetitionPage";

interface ColorPickerProps {
  onChange?: (color: string) => void
  value: string,
  label?: string;
  vTYPE?: string
  isCompetition?: boolean;
  isShort?: boolean;
  isButtonColor?: boolean;
  isProDeziiign?: boolean;
  mobileLeftOffset?: string | number;
}

const COLORS = [
  Colors.gal, '#d52b1e', '#ffc19c', '#ffbc3d', '#bed600', '#3d7edb', '#aacae6', '#f5ec5a',
  '#000000', '#d1d4d3', '#5e6a71', '#e2ddcb', '#aea79f', '#bcd4c3', '#394a58',
];

export const WIDE_SCREEN_COLORS = [Colors.gal, '#000000', '#d1d1d1'];

const ColorPicker: FC<ColorPickerProps> = ({ value, onChange, vTYPE, isCompetition, isShort, label, isButtonColor, isProDeziiign, mobileLeftOffset }) => {
  const { t } = useTranslation();
  const isTeamEdit = useRouteMatch('/team-edit');
  const vtype = useSelector((state: any) => state?.vt?.vtype);
  const colorPickerButton = useRef<HTMLDivElement>(null);
  const [picker, togglePicker] = useState(false);
  const isWideLongread = !isTeamEdit && !vTYPE && vtype === 'fluid';
  const isProjectEditPage = !!useRouteMatch(['/edit', '/books/edit'])

  const colorList = useMemo(() => {
    if (isWideLongread) {
      return WIDE_SCREEN_COLORS.map((color) => (
        <ColorElement
          isCompetition={isCompetition}
          key={color}
          color={color}
          selected={value === color}
          currentBackground={value}
          onClick={() => onChange?.(color)}
        />
      ))
    }
    return COLORS?.filter((color) => {
      if (isShort) {
        return [Colors.gal, '#000000']?.includes(color)
      }

      return color;
    }).map((color) => {
      const clr = isCompetition && color === '#FEFEFE' ? '#343434' : color;

      return (
        <ColorElement
        isCompetition={isCompetition}
        key={clr}
        color={clr}
        selected={value === clr}
        currentBackground={value}
        onClick={() => onChange?.(clr)}
      />
      )
    })
  }, [value, onChange, isWideLongread, isCompetition]);


  return (
    <ProjectEditPageGridRow  direction={'row'} directionMobile={isShort ? 'row' : 'column'} className="mobile__hide" align={isCompetition || isShort ? "center" : "flex-start"} isProDeziiign={isProDeziiign}>
      {isCompetition
          ? 
            <CompetitionEditPageGridLabel className={'color-picker-label'}>
              {t('project_edit.background')}
            </CompetitionEditPageGridLabel>
          : 
          isShort ? 
            <ProjectEditPageGridLabel className={'color-picker-label'}>
              {label}
            </ProjectEditPageGridLabel> 
          : 
            <ProjectEditPageGridLabel isProjectEditPage={isProjectEditPage} className={'color-picker-label'}>
              {t('project_edit.background')}
            </ProjectEditPageGridLabel>}
      <ColorPickerWrapper>
       {colorList}
        {!isWideLongread && !isButtonColor && (
          <UserColorChoose className={'user-color-choose'}>
            <ChangeBgBtn ref={colorPickerButton} onClick={() => togglePicker(!picker)}/>
            {picker && (
              <ClickAwayListener onClickAway={({ target }) => {
                if (target !== colorPickerButton.current) {
                  togglePicker(!picker)
                }
              }}>
                <UserColorChooseBlock mobileLeftOffset={mobileLeftOffset}>
                  <SketchPicker
                    color={value}
                    onChangeComplete={(color) => onChange?.(color.hex)}
                    presetColors={COLORS}
                    disableAlpha
                  />
                </UserColorChooseBlock>
              </ClickAwayListener>
            )}
          </UserColorChoose>
        )}
      </ColorPickerWrapper>
    </ProjectEditPageGridRow>
  )
}

export default ColorPicker;
import { FC, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  ChangeBgBtn,
  ProjectEditPageGridLabel,
  ProjectEditPageGridRow,
  UserColorChoose,
  UserColorChooseBlock
} from "../../styles";
import { ColorElement, ColorPickerWrapper } from "./styles";
import { Colors } from "@brg/ui";
import { useSelector } from "react-redux";
import SketchPicker from "react-color/lib/components/sketch/Sketch";
import ClickAwayListener from "react-click-away-listener";
import { useRouteMatch } from "react-router-dom";
import {
  CompetitionEditPageGridLabel
} from "../../../../../_competition/pages/CreateCompetitionPage/CreateCompetitionPage";

interface ColorPickerProps {
  onChange?: (color: string) => void
  value: string,
  label?: string;
  vTYPE?: string
  isCompetition?: boolean;
  isShort?: boolean;
  isButtonColor?: boolean;
  isProDeziiign?: boolean;
  mobileLeftOffset?: string | number;
}

const COLORS = [
  Colors.gal, '#d52b1e', '#ffc19c', '#ffbc3d', '#bed600', '#3d7edb', '#aacae6', '#f5ec5a',
  '#000000', '#d1d4d3', '#5e6a71', '#e2ddcb', '#aea79f', '#bcd4c3', '#394a58',
];

export const WIDE_SCREEN_COLORS = [Colors.gal, '#000000', '#d1d1d1'];

const ColorPicker: FC<ColorPickerProps> = ({ value, onChange, vTYPE, isCompetition, isShort, label, isButtonColor, isProDeziiign, mobileLeftOffset }) => {
  const { t } = useTranslation();
  const isTeamEdit = useRouteMatch('/team-edit');
  const vtype = useSelector((state: any) => state?.vt?.vtype);
  const colorPickerButton = useRef<HTMLDivElement>(null);
  const [picker, togglePicker] = useState(false);
  const isWideLongread = !isTeamEdit && !vTYPE && vtype === 'fluid';
  const isProjectEditPage = !!useRouteMatch(['/edit', '/books/edit'])

  const colorList = useMemo(() => {
    if (isWideLongread) {
      return WIDE_SCREEN_COLORS.map((color) => (
        <ColorElement
          isCompetition={isCompetition}
          key={color}
          color={color}
          selected={value === color}
          currentBackground={value}
          onClick={() => onChange?.(color)}
        />
      ))
    }
    return COLORS?.filter((color) => {
      if (isShort) {
        return [Colors.gal, '#000000']?.includes(color)
      }

      return color;
    }).map((color) => {
      const clr = isCompetition && color === '#FEFEFE' ? '#343434' : color;

      return (
        <ColorElement
        isCompetition={isCompetition}
        key={clr}
        color={clr}
        selected={value === clr}
        currentBackground={value}
        onClick={() => onChange?.(clr)}
      />
      )
    })
  }, [value, onChange, isWideLongread, isCompetition]);


  return (
    <ProjectEditPageGridRow  direction={'row'} directionMobile={isShort ? 'row' : 'column'} className="mobile__hide" align={isCompetition || isShort ? "center" : "flex-start"} isProDeziiign={isProDeziiign}>
      {isCompetition
          ? 
            <CompetitionEditPageGridLabel className={'color-picker-label'}>
              {t('project_edit.background')}
            </CompetitionEditPageGridLabel>
          : 
          isShort ? 
            <ProjectEditPageGridLabel className={'color-picker-label'}>
              {label}
            </ProjectEditPageGridLabel> 
          : 
            <ProjectEditPageGridLabel isProjectEditPage={isProjectEditPage} className={'color-picker-label'}>
              {t('project_edit.background')}
            </ProjectEditPageGridLabel>}
      <ColorPickerWrapper>
       {colorList}
        {!isWideLongread && !isButtonColor && (
          <UserColorChoose className={'user-color-choose'}>
            <ChangeBgBtn ref={colorPickerButton} onClick={() => togglePicker(!picker)}/>
            {picker && (
              <ClickAwayListener onClickAway={({ target }) => {
                if (target !== colorPickerButton.current) {
                  togglePicker(!picker)
                }
              }}>
                <UserColorChooseBlock mobileLeftOffset={mobileLeftOffset}>
                  <SketchPicker
                    color={value}
                    onChangeComplete={(color) => onChange?.(color.hex)}
                    presetColors={COLORS}
                    disableAlpha
                  />
                </UserColorChooseBlock>
              </ClickAwayListener>
            )}
          </UserColorChoose>
        )}
      </ColorPickerWrapper>
    </ProjectEditPageGridRow>
  )
}

export default ColorPicker;
